import React, { Fragment } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { CarouselProvider, Slider, Slide, Dot } from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";
import Carousel from "./Carousel/Carousel";
import "./Jumbo.css";
import "./button.css";
import { Dimensions } from "../../Helper/sitedimension";

class Jumbo extends React.Component {
  widthHandler() {
    const { width } = Dimensions.useWindowDimensions();
    return width;
  }
  render() {
    const carouselStyle = {
      position: "relative",
      top: "120px"
    };
    return (
      <div className="container-fluid jumbotron">
        <Row>
          <Col className="col-4 container-fluid p-0">
            <div style={carouselStyle}>
              <CarouselProvider
                naturalSlideHeight={400}
                naturalSlideWidth={620}
                totalSlides={3}
                isPlaying={true}
                interval={3000}
              >
                <div className="container-fluid p-0">
                  <div className="container-fluid crs-content">
                    {console.log(this.widthHandler)}
                    <Slider>
                      <Slide className="" index={0}>
                        <Carousel
                          main="Cyber Security"
                          main2="Re-Engineered"
                          content="Secure Blink works on an AI mechanism which fences critical servers and organization assets against cyber attacks. It scans your system thoroughly and provides detailed reports of any suspect."
                        />
                      </Slide>
                      <Slide className="" index={0}>
                        <Carousel
                          main="AI Enabled"
                          main2="Products"
                          content="A holistic cyber security solution with the power of AI to tackle the most hazardous attack on your system. It renders system and scores your website on the basis of its security level."
                        />
                      </Slide>
                      <Slide className="" index={0}>
                        <Carousel
                          main="Predicting"
                          main2=" Future Attacks"
                          content="Efficiency and risk management are at the core of Secure Blink. There is an internal mechanism to predict the rate of future attacks on your system and provide deep insights regarding the possibility of threats."
                        />
                      </Slide>
                    </Slider>
                  </div>
                  <div className="container-fluid text-left btn-grp buttons">
                    <Dot slide={0} className="btn" />
                    <Dot slide={1} className="btn" />
                    <Dot slide={2} className="btn" />
                  </div>
                </div>
              </CarouselProvider>
            </div>
          </Col>
          <Col className="col-8"></Col>
        </Row>
      </div>
    );
  }
}
export default Jumbo;
